import axiosService from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';

const userConfigurationService = {
  setFCMToken(token: string) {
    return axiosService.post(getEndpointBase('user/configuration/fcm_token'), {
      token,
    });
  },
};

export default userConfigurationService;
